import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLS } from '../../environments/environment';
import { firstValueFrom, map, Observable, ReplaySubject, Subject, shareReplay, tap } from 'rxjs';
import { MapPoint } from '../models/map-point';
import { GeoJsonFeatureCollection, GeoJsonFeature, FeatureCompact } from '../models/geo-json-feature';
import { RandomCategory } from '../models/random-category';
import { NuevaFichaGeoJSON } from '../models/nueva-ficha';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private httpClient: HttpClient) { }

  getPoints(): Observable<MapPoint[]> {
    const url = URLS.API + URLS.PUNTOS_MAPA;
    return this.httpClient.get<MapPoint[]>(url);
  }

  getCompactFeatures(): Observable<FeatureCompact[]> {
    const url = URLS.API + URLS.GEOSON_SLIM;
    return this.httpClient.get<FeatureCompact[]>(url).pipe(
      tap(data => console.log('FeatureCompact Data:', data)),
      shareReplay(1)
    );
  }

  getFeatureById(id: number, idioma?: string): Observable<GeoJsonFeature> {
    const url = URLS.API + URLS.FICHA + id;
    let params = new HttpParams();
    if (idioma) {
      params = params.set('idioma', idioma);
    }
    return this.httpClient.get<GeoJsonFeature>(url, { params });
  }

  getRandomCategories(): Observable<RandomCategory[]> {
    const url = URLS.API + URLS.ALEATORIO;
    return this.httpClient.get<RandomCategory[]>(url);
  }


  getGeoJson(options?: { idioma?: string; categoria?: string }): Observable<GeoJsonFeatureCollection> {
    const url = URLS.API + URLS.GEOJSON;
    let params = new HttpParams();
    if (options?.idioma) {
      params = params.set('idioma', options.idioma);
    }
    if (options?.categoria) {
      params = params.set('categoria', options.categoria);
    }
    return this.httpClient.get<GeoJsonFeatureCollection>(url, { params });
  }

  createWonder(ficha: NuevaFichaGeoJSON): Observable<any> {
    const url = URLS.API + URLS.NUEVA_FICHA;
    return this.httpClient.post(url, ficha);
  }

  deleteWonder(globalid: string): Observable<any> {
    const url = URLS.API + URLS.ELIMINAR_FICHA;
    const params = new HttpParams().set('globalid', globalid);
    return this.httpClient.post(url, null, { params });
  }

  exportFormulariosXlsx(): Observable<Blob> {
    const url = URLS.API + URLS.EXPORTAR_XLSX;
    return this.httpClient.get(url, { responseType: 'blob' });
  }
}
